import {Card, Col, Statistic} from "antd";

const CardAmount = (props) => {
  const { lots } = props;
  return (
    <>
      <Col
        xs={{ span: 24 }}
        md={{ span: 12 }}
        lg={{ span: 12 }}
        xl={{ span: 4}}
      >
        <Card style={{padding: '10px 15px',boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'}}>
          <Statistic
            title="C.A Prop."
            value={lots.reduce((somme, element) => somme + element.total_ca, 0)}
            groupSeparator=" "
            decimalSeparator=","
            precision={2}
            suffix=" €"
          />
        </Card>
      </Col>

      <Col
        xs={{ span: 24 }}
        md={{ span: 12 }}
        lg={{ span: 12 }}
        xl={{ span: 4 }}
      >
        <Card style={{padding: '10px 15px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'}}>
          <Statistic
            title="Honoraires Agence"
            value={lots.reduce((somme, element) => somme + element.owner_fee, 0)}
            groupSeparator=" "
            decimalSeparator=","
            precision={2}
            suffix=" €"
          />
        </Card>
      </Col>

      <Col
        xs={{ span: 24 }}
        md={{ span: 12 }}
        lg={{ span: 12 }}
        xl={{ span: 4 }}
      >
        <Card style={{padding: '10px 15px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'}}>
          <Statistic
            title="Honoraires Autres"
            value={lots.reduce((somme, element) => somme + element.agency_fee, 0)}
            groupSeparator=" "
            decimalSeparator=","
            precision={2}
            suffix=" €"
          />
        </Card>
      </Col>

      <Col
        xs={{ span: 24 }}
        md={{ span: 12 }}
        lg={{ span: 12 }}
        xl={{ span: 4 }}
      >
        <Card style={{padding: '10px 15px',boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'}}>
          <Statistic
            title="Total Honoraires"
            value={lots.reduce((somme, element) => somme + element.fees, 0)}
            groupSeparator=" "
            decimalSeparator=","
            precision={2}
            suffix=" €"
          />
        </Card>
      </Col>
      <Col
        xs={{ span: 24 }}
        md={{ span: 12 }}
        lg={{ span: 12 }}
        xl={{ span: 4 }}
      >
        <Card style={{padding: '10px 15px',boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'}}>
          <Statistic
            title="Total Nuitées"
            value={lots.reduce((somme, element) => somme + element.rented, 0)}
            groupSeparator=""
            //decimalSeparator=","
            //precision={2}
            //suffix=" €"
          />
        </Card>
      </Col>
      <Col
        xs={{ span: 24 }}
        md={{ span: 12 }}
        lg={{ span: 12 }}
        xl={{ span: 4 }}
      >
        <Card style={{padding: '10px 15px',boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'}}>
          <Statistic
            title="Total Locations"
            value={lots.reduce((somme, element) => somme + element.number, 0)}
            groupSeparator=""
            //decimalSeparator=","
            //precision={2}
            //suffix=" €"
          />
        </Card>
      </Col>
    </>
  );
};

export default CardAmount;